<template>
  <div class="animated fadeIn">
    <b-card-text class="text-left">
      <p>
        You're just a few clicks away from greater insight into your Slack workspace!
      </p>

      <p>
        Click 'Next' to continue
      </p>
    </b-card-text>

    <div v-if="codeSubmitted" class="d-flex justify-content-center mb-3">
      <b-spinner label="Installing..."></b-spinner>
    </div>

    <b-button :disabled="nextButtonDisabled" class="float-right" href="#" variant="primary" @click="nextButtonClick">Next</b-button>
  </div>
</template>


<script>
export default {
  name: 'Step1',
  props: {
    msg: String
  },

  data: function () {
    return {
      nextButtonDisabled: false,
      codeSubmitted: false
    }
  },

  methods: {
    nextButtonClick() {
      if(!this.codeSubmitted) {
        this.$store.commit('installProgress', 25)
        this.$store.dispatch('submitInstallCode', this.$store.state.installCode)
        this.nextButtonDisabled = true
        this.codeSubmitted = true
      } else {
        console.log('code already submitted')
      }
    }
  },

  mounted() {
    this.$store.commit('installProgress', 5)
  }
}
</script>